
























































import moment from 'moment';
import { COMPANY_STATUS } from 'gl-ms-offers';
import {
    NEXT_ACTIVE,
    PRE_ACTIVE,
    UPDATE_STATUS,
    UPLOAD_OFFERS,
} from '@/store/modules/offersModule';
import eventBus, { EVENTS_TYPE } from '@/services/eventbus';
import ftlOffer from '@/services/jsreport';
import offerMixins from '@/helpers/offers/offerMixin';
import OfferTag from './components/offerTags.vue';

export default {
    mixins: [offerMixins],
    components: {
        OfferTag,
    },
    data() {
        return {
            closed: COMPANY_STATUS.CLOSED,
            pending: COMPANY_STATUS.PENDING,
        };
    },
    computed: {
        active(this: any) {
            return this.$store.getters.getActive;
        },
        valid(this: any) {
            return this.$store.getters.getValid;
        },
        isEdit(this: any) {
            return this.$store.getters.isEdit_offer;
        },
    },
    methods: {
        next(this: any) {
            this.saveForm(1);
            this.referRoute('offers-add-set2', NEXT_ACTIVE);
        },

        convertDate(date: Date): any {
            return new Date(`${moment(date as Date).format('YYYY-MM-DDT00:00:00.000').toString()}Z`);
        },

        pre(this: any) {
            this.saveForm(1);
            this.referRoute('offers-add-set1', PRE_ACTIVE);
        },

        async saveForm(this: any, sav: number) {
            this.checkValid();
            // eslint-disable-next-line
            const offerId = this.offersData._id;

            // As a temporary solution we just get the ISO DATE from the date objects
            const additional = { date: this.convertDate(this.offersData.date), validityDate: this.convertDate(this.offersData.validityDate) };

            // end temporary solution
            const invalidLanes = this.offersData.lanes.filter(
                (q: any) => q.collections.find((c: any) => !c.zone)
            || q.deliveries.find((d: any) => !d.zone),
            ) || [];
            if (this.valid && invalidLanes.length == 0) {
                this.offersData.lanes.forEach((el: any) => {
                    el.dateFrom = this.convertDate(el.dateFrom);
                    el.dateTo = this.convertDate(el.dateTo);
                });

                // SAVE
                if (this.isEdit || !sav) {
                    const success = await this.$store.dispatch(UPLOAD_OFFERS, { ...this.offersData, ...additional });
                    if (success) {
                        if (!sav && offerId) {
                            this.confirmStatus(
                                this.$t('offer.do_you_want'),
                                this.$t('offer.offr_success'),
                                this.$t('offer.remain'),
                                this.$t('offer.confirm_no'),
                                'success',
                                1,
                            )
                                .then(() => {})
                                .catch((action: any) => {
                                    if (action === 'cancel') this.$router.push({ name: 'customers-offers-list' });
                                });
                        } else if (!sav && !offerId) {
                            this.$message({
                                type: 'success',
                                message: this.$t('offer.offr_success'),
                            });
                            this.$router.push({ name: 'customers-offers-list' });
                        }
                    } else {
                        this.$message({
                            type: 'error',
                            message: this.$t('common.errorMessage'),
                        });
                    }
                }
            }
        },

        referRoute(this: any, routeName: string, commitID: string) {
            if (this.valid) {
                if (this.offerId) {
                    this.$router.push({
                        name: routeName,
                        query: { id: this.offerId },
                    });
                    return;
                }
                this.$router.push({ name: routeName });
                this.$store.commit(commitID);
            }
        },

        confirmStatus(
            this: any,
            value: string,
            text: string,
            confirmButtonText: string,
            cancelButtonText: string,
            type: string,
            dis?: number,
        ) {
            return this.$confirm(value, text, {
                distinguishCancelAndClose: !!dis,
                confirmButtonText,
                cancelButtonText,
                type,
            });
        },

        checkValid(this: any) {
            eventBus.$emit(EVENTS_TYPE.VALID_TYPE, false);
        },

        alert(this: any, val: string, ide?: number) {
            if (!ide) {
                this.$alert(val, this.$t('offer.alert_warning'), {
                    confirmButtonText: this.$t('offer.alert_ok'),
                    type: 'warning',
                });
            } else {
                this.confirmStatus(
                    val,
                    this.$t('offer.alert_info'),
                    this.$t('offer.confirm_yes'),
                    this.$t('offer.confirm_no', 'info'),
                ).then(() => {
                    this.updateStatus(this.closed);
                });
            }
        },

        async genPdf(this: any) {
            const offerData = this.offersData;
            const tempName = `Offer_${offerData.number}_${offerData.branch}_${offerData.year}`;
            const speakerLang = offerData.customer.contact.language;
            ftlOffer.downloadDocument('FtlOffer', tempName, offerData, speakerLang);
        },
        async savePdf(this: any) {
            if (!this.offersData._id) {
                this.alert(this.$t('offer.pls_save_create'));
            } else if (this.offersData.status !== this.pending) {
                await this.genPdf();
                this.updateStatus(this.pending);
            } else {
                this.genPdf();
            }
        },

        closeOffer(this: any) {
            if (this.offersData.lanes.length) {
                const checkResult = this.offersData.lanes.every(
                    (el: any) => el.result !== '',
                );
                if (this.offersData.status !== this.pending) {
                    this.alert(this.$t('offer.shld_be_pending'));
                    return;
                }
                if (!checkResult) {
                    this.alert(this.$t('offer.check_result'));
                    return;
                }
                this.alert(this.$t('offer.close_the_offr'), 2);
                return;
            }
            this.alert(this.$t('offer.add_lanes'));
        },

        async updateStatus(this: any, val: string) {
            const payload = {
                id: this.offersData._id,
                status: val,
            };
            try {
                await this.$store.dispatch(UPDATE_STATUS, payload);
                this.confirmStatus(
                    this.$t('offer.do_you_want'),
                    this.$t('offer.status_success'),
                    this.$t('offer.remain'),
                    this.$t('offer.confirm_no'),
                    'success',
                    1,
                )
                    .then(() => {})
                    .catch((action: any) => {
                        if (action === 'cancel') this.$router.push({ name: 'customers-offers-list' });
                    });
            } catch (e) {
                this.$message({
                    type: 'error',
                    message: this.$t('offer.smthng_went_wrong'),
                });
            }
        },
    },

    beforeRouteLeave(this: any, to: any, from: any, next: any) {
        if (to.name === 'customers-offers-list') {
            next();
            return;
        }
        this.confirmStatus(
            this.$t('offer.discardOrSave'),
            this.$t('offer.alert_warning'),
            this.$t('offer.keep'),
            this.$t('offer.discard'),
            'warning',
            1,
        )
            .then(() => {
                this.saveForm(1);
                next();
            })
            .catch((action: any) => {
                if (action === 'cancel') next();

                next(false);
            });
    },
};
